<script>
  import { TIME, IS_PLAYING, IS_INTERFACE_VISIBLE, IS_LOADED, IS_STOPPED, IS_LOADING, IS_FINISHED } from '../stores.js';
  import Player from '@vimeo/player';
  import { vimeoSetting, PLAYER_FINISHED_PADDING } from '../config';
  import { onMount } from 'svelte';
  import Meta from './Meta.svelte';
  import Controls from './Controls.svelte';
  import Status from './Status.svelte';

  let player;
  let duration = 0;

  onMount(() => {
    player = new Player('geocinema', { url: 'https://vimeo.com/440923569/40541236e5' })

    player.on('error', function (error) {
      console.log(error)
    })

    player.on('loaded', function () {
      IS_LOADED.set(true);

      player.getDuration().then(function (v) {
        duration = v
      });
    })

    player.on('timeupdate', (e) => {
      const { seconds } = e;
      updateTime(seconds)
      if (seconds > PLAYER_FINISHED_PADDING && seconds > duration - PLAYER_FINISHED_PADDING) {
        // Fade out one second before end to avoid Vimeo glitch
        IS_FINISHED.set(true);
      }
    });

    player.on('ended', function () {
      IS_FINISHED.set(true);
      IS_PLAYING.set(false);
      IS_STOPPED.set(true);
    })
  })

  function updateTime (newTime) {
    TIME.set(newTime);
  }

  let isFinished;
  IS_FINISHED.subscribe(v => {
    isFinished = v;
  });

  window.start = () => {
    if (isFinished) {
      updateTime(0)
      player.setCurrentTime(0)
    }
    play();
  }

  window.play = () => {
    player.getPaused().then((paused) => {
      // console.log({paused})
      if (paused) {
        IS_LOADING.set(true)
        player.play().then(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          IS_FINISHED.set(false)
          IS_PLAYING.set(true)
          IS_STOPPED.set(false)
          IS_LOADING.set(false)
        }).catch((error) => {
          switch (error.name) {
            case 'PasswordError':
              // The video is password-protected
              console.log('password protected')
              break;
            case 'PrivacyError':
              console.log('private')
              // The video is private
              break;

            default:
              // Some other error occurred
              console.log('error', error)
              break;
          }
        });
      }
    });
  }

  window.pause = () => {
    player.pause();
    IS_PLAYING.set(false)
  }

  window.stop = () => {
    player.pause();
    IS_STOPPED.set(true)
  }

  function toggePlay () {
    player.getPaused().then((paused) => {
      if (paused) {
        window.play();
      } else {
        window.stop();
      }
    })
  }

  window.goToSecond = (seconds) => {
    updateTime(seconds)
    player.setCurrentTime(seconds)
    play();
  }

  function handleKeydown ({ keyCode }) {
    switch (keyCode) {
      case 32:
        toggePlay();
        break;
      case 27:
        toggePlay();
        break;
    }
  }
</script>

<svelte:window on:keydown={ handleKeydown } />

<Controls />
<Meta />
<Status />
